<template>
  <div id="custom-table-list" class="custom-table-container">
    <vs-popup fullscreen title="Pré-visualização do Template" :active.sync="isPopupActive">
      <span v-html="convertTemplateContent(templateContent)"></span>
    </vs-popup>

    <vs-button
      color="primary" 
      type="flat" 
      style="width: 100%;" 
      class="mb-5 text-left"
      @click.stop="chooseTemplate(null)"
    >
      <span>Criar campanha sem selecionar um template</span>
      <feather-icon
        icon="ArrowRightIcon"
        svgClasses="w-5 h-5 ml-2 stroke-current"
        title="Escolher"
      />
    </vs-button>

    <vs-table
      ref="table"
      pagination
      :sst="true"
      :currentPage="currentPage"
      @change-page="handleChangePage"
      @sort="handleSort"
      @search="handleSearch"
      noDataText="Sem dados disponíveis"
      :max-items="itemsPerPage"
      search
      :data="templates"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          :showAddButton="false"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th colspan="2"></vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p
                class="product-name font-medium"
                @click.stop="chooseTemplate(tr.id)"
              >
                {{ tr.name }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                title="Pré-visualizar"
                @click.stop="previewTemplate(tr)"
              />
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="ArrowRightIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                title="Escolher"
                @click.stop="chooseTemplate(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleTemplate from '@/store/newsletter/template/moduleTemplate'
  import { defineSortFieldDirection, decodeFromBase64 } from '@/utils'

  export default {
    name: 'templates-list',
    components: {
      ActiveItem,
      HeaderList
    },
    data() {
      return {
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        templateContent: '',
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        },
        isPopupActive: false
      }
    },
    computed: {
      templates() {
        return this.$store.state.newsletterTemplate.templates
      }
    },
    methods: {
      chooseTemplate(templateId) {
        const template = templateId ? { template: templateId } : ''

        this.$router.push({
          path: '/newsletter/campaigns/create',
          query: template
        })
      },
      convertTemplateContent(content) {
        if (content === ""){
          return '';
        }

        return decodeFromBase64(content)
      },
      previewTemplate(data) {
        this.templateContent = this.$_.cloneDeep(data.content)
        this.isPopupActive = true
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            name: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage(page) {
        this.currentPage = page
        this.fetchData()
      },
      fetchData() {
        if (moduleTemplate.isRegistered) {
          this.$store.dispatch("newsletterTemplate/fetch", {
            ...this.searchField,
            ...{ order_by: this.sortField.current },
            activated: true
          })
        }
      }
    },
    created() {
      this.resetSortField();

      if (!moduleTemplate.isRegistered) {
        this.$store.registerModule('newsletterTemplate', moduleTemplate)
        moduleTemplate.isRegistered = true
      }
      
      this.fetchData();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>
